import { GetContentFunction } from '../hooks/useLocalizedContent'
import {
  MORE_OPTIONS_ITEMS,
  MoreOptionsItem,
} from '../screens/groupdetail/v1.1/components/ActionButtons/MoreOptionsButton'
import { isGroupCreationEnabled } from './features'

export interface MoreOptionsParams {
  isActive: boolean
  isPayPalUser: boolean
  isAdmin: boolean
  reportLink: string
  getContent: GetContentFunction
  onCreateClick: () => void
  onCloseClick: () => void
  onReportClick: () => void
}

export const getMobileOptions = ({
  isActive,
  isPayPalUser,
  isAdmin,
  onCreateClick,
  onCloseClick,
  getContent,
}: MoreOptionsParams) => {
  const moreOptionsItems: MoreOptionsItem[] = []

  if (!isActive) {
    return []
  }

  if (isPayPalUser && isGroupCreationEnabled()) {
    moreOptionsItems.push({
      ...MORE_OPTIONS_ITEMS.CREATE,
      onClick: onCreateClick,
      actionMenuItem: {
        ...MORE_OPTIONS_ITEMS.CREATE.actionMenuItem,
        label: getContent(MORE_OPTIONS_ITEMS.CREATE.actionMenuItem.label),
      },
    })
  }

  if (isAdmin) {
    moreOptionsItems.push({
      ...MORE_OPTIONS_ITEMS.CLOSE,
      onClick: onCloseClick,
      actionMenuItem: {
        ...MORE_OPTIONS_ITEMS.CLOSE.actionMenuItem,
        label: getContent(MORE_OPTIONS_ITEMS.CLOSE.actionMenuItem.label),
      },
    })
  }

  return moreOptionsItems
}

export const getDesktopOptions = ({
  isActive,
  isPayPalUser,
  isAdmin,
  reportLink,
  onCreateClick,
  onCloseClick,
  onReportClick,
  getContent,
}: MoreOptionsParams) => {
  const moreOptionsItems: MoreOptionsItem[] = []
  const isNonCreatorUserOnClosedGroup =
    !isGroupCreationEnabled() && isPayPalUser && !isActive

  if (isActive) {
    if (isPayPalUser && isGroupCreationEnabled()) {
      moreOptionsItems.push({
        ...MORE_OPTIONS_ITEMS.CREATE,
        onClick: onCreateClick,
        actionMenuItem: {
          ...MORE_OPTIONS_ITEMS.CREATE.actionMenuItem,
          label: getContent(MORE_OPTIONS_ITEMS.CREATE.actionMenuItem.label),
        },
      })
    }

    if (isAdmin) {
      moreOptionsItems.push({
        ...MORE_OPTIONS_ITEMS.CLOSE,
        onClick: onCloseClick,
        actionMenuItem: {
          ...MORE_OPTIONS_ITEMS.CLOSE.actionMenuItem,
          label: getContent(MORE_OPTIONS_ITEMS.CLOSE.actionMenuItem.label),
        },
      })
    }
  }

  if (!isAdmin && !isNonCreatorUserOnClosedGroup) {
    moreOptionsItems.push({
      ...MORE_OPTIONS_ITEMS.REPORT,
      onClick: onReportClick,
      actionMenuItem: {
        ...MORE_OPTIONS_ITEMS.REPORT.actionMenuItem,
        label: getContent(MORE_OPTIONS_ITEMS.REPORT.actionMenuItem.label),
        navigationOptions: {
          ...MORE_OPTIONS_ITEMS.REPORT.actionMenuItem.navigationOptions,
          href: reportLink,
        },
      },
    })
  }

  return moreOptionsItems
}
